import type { ReactNode } from "react";

export function FilterDisclosure({children,activeCount=0,summary,title="Filters"}:{children:ReactNode;activeCount?:number;summary?:string;title?:string}){
  return <details className="filter-disclosure">
    <summary>
      <span className="filter-disclosure-title"><span className="filter-disclosure-icon" aria-hidden="true">⌕</span><strong>{title}</strong>{activeCount>0&&<span className="filter-active-count">{activeCount} active</span>}</span>
      <span className="filter-disclosure-summary">{summary}</span>
      <span className="filter-disclosure-chevron" aria-hidden="true">⌄</span>
    </summary>
    <div className="filter-disclosure-body">{children}</div>
  </details>;
}
